export const REQUEST_FOR_EMAIL_BENCHMARK = 'REQUEST_FOR_EMAIL_BENCHMARK';
export const EMAIL_SUCCESS_BENCHMARK = 'EMAIL_SUCCESS_BENCHMARK';
export const EMAIL_ERROR_BENCHMARK = 'EMAIL_ERROR_BENCHMARK';

export const REQUEST_FOR_EMAIL_SHAREAPP = 'REQUEST_FOR_EMAIL_SHAREAPP';
export const EMAIL_SUCCESS_SHAREAPP = 'EMAIL_SUCCESS_SHAREAPP';
export const EMAIL_ERROR_SHAREAPP = 'EMAIL_ERROR_SHAREAPP';
